import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import bomService from "../services/bom-service";
import type { CreateBomData, UpdateBomData } from "../../types/bom";
import { queryClient } from "@/query-client";

// fetches the list of boms
export const bomsQueryOptions = (params: Record<string, unknown> = {}) =>
    queryOptions({
        queryKey: ["boms", params],
        queryFn: () => bomService.list(params),
        staleTime: 1000 * 60 * 60,
    });

export const useBoms = () => useQuery(bomsQueryOptions());

export const useBomOptions = () => {
    const query = useBoms();
        const options = (query.data ?? []).map((origin) => ({
            value: origin.supplier_name,
            label: origin.supplier_name,
        }));
        return { ...query, options };
}

// fetches single bom by id 
export const bomQueryOptions = (id: string) =>
    queryOptions({
        queryKey: ['bom', id],
        queryFn: () => bomService.findById(id),
    });

// create bom
// useMutation defines how to create, updata and delete data
export const useBomCreateMutation = () =>
    useMutation({
        mutationFn: (bom: CreateBomData) => bomService.create(bom),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["boms"]
            })
        },
    })

// update bom // for updating data
export const useBomUpdateMutation = (id: string) =>
    useMutation({
        mutationFn: (bom: UpdateBomData) => bomService.updateById(id, bom),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["boms"], // refresh the list/ table
            });
            queryClient.invalidateQueries({
                queryKey: ['bom'], // refresh the updated bom (single)
            });
        },
    })

export const useBomDeleteMutation = () =>
    useMutation({
        mutationFn: (id: string) => bomService.deleteById(id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["boms"],
            });
        },
    });

// Documentation and understanding

// import { queryOptions, useMutation } from "@tanstack/react-query";
//      queryOptions - defines how to fetch data

// useMutation - for writing data

// When you submit a create form, the form data gets passed here and sent to Laravel.
// mutationfn: actual API call 
// mutationFn: (bom: CreateBomData) => bomService.create(bom),
// (bom: CreateBomData) - data from my form 
// bomService.create(bom), - then calls POST /api/bom

// onSuccess — runs AFTER the create succeeds:
// onSuccess: () => {
//     queryClient.invalidateQueries({
//         queryKey: ["boms"] // tells TanStack Query "boms list is outdated!"
//     })
// },
// After creating a new BOM, the list needs to refresh to show the new item. `invalidateQueries` says "hey, refetch anything with key `["boms"]`"!

// next to create is its route eg. _dashboard.bom.tsx